"use strict";

exports.__esModule = true;
exports.TabsWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _widget = require("../Tab/widget");
var _EditableTabsElement = require("./EditableTabsElement");
var _TabsElement = require("./TabsElement");
var _TabsFields = require("./TabsFields");
var _TabsHeader = require("./TabsHeader");
var _TabsThumbnail = require("./TabsThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TabsWidget = exports.TabsWidget = {
  name: "Tabs",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TabsWidget.label",
    defaultMessage: "Tabs"
  }),
  group: _widgetGroups.LAYOUT_WIDGET,
  icon: "folder-close",
  createElement: function createElement(props) {
    return {
      type: "Tabs",
      props: Object.assign({
        id: Math.random().toString(16).slice(2),
        width: 512,
        height: 512,
        flex: 1
      }, props),
      children: [_widget.TabWidget.createElement({
        title: "Tab 1"
      })]
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["orientation"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 512,
      min: 128,
      max: 3840
    },
    height: {
      "default": 512,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _TabsHeader.TabsHeader,
    Element: _TabsElement.TabsElement,
    Fields: _TabsFields.TabsFields,
    Thumbnail: _TabsThumbnail.TabsThumbnail,
    Editable: _EditableTabsElement.EditableTabsElement
  }
};